<mat-form-field
    class="form-full-width"
    appearance="outline"
    [formGroup]="group"
    [style.fontSize.px]="14"
    [ngClass]="{ 'leading-icon': field?.leadingIcon, 'trailing-button': field?.trailingButton }"
>
    <i matPrefix *ngIf="field?.leadingIcon" [ngClass]="'mdi mdi-' + field?.leadingIcon" class="input_leading-icon"></i>
    <mat-label>{{ field.label ? field.label : '' }}</mat-label>
    <input
        matInput
        [formControl]="group.get(field.name)"
        [type]="field.inputType === 'password' ? (!field.hide ? 'password' : 'text') : field.inputType"
        [minlength]="field.minlength ? field.minlength : '0'"
        [autocomplete]="field.autoComplete"
        [required]="field.required"
        [maxlength]="field.maxlength ? field.maxlength : '255'"
        [app-restrict-input]="field.mask ? field.mask : data && data.mask ? data.mask : null"
        [app-restrict-input-regex]="{ regExp: field.regex, fieldName: field.name }"
        [app-restrict-input-control]="group?.get(field.name)"
        [app-restrict-input-precision]="field.precision"
        [id]="field.id ? field.id : null"
        [readonly]="field.is_block"
        (blur)="applyDecimalPrecision()"
    />
    <mat-hint *ngIf="field.hint" [innerHtml]="field.hint" [ngClass]="'input_tooltip'" [title]="field.hint"></mat-hint>
    <mat-hint *ngIf="field.maxlength" align="end">
        {{ group?.get(field.name).value?.length ?? 0 }} / {{ field.maxlength }}</mat-hint
    >
    <fui-button
        *ngIf="!field?.hideClearButton && group?.get(field.name).value && !field.disabled && !field.is_block"
        (clickEvent)="group?.get(field.name).setValue(''); group?.get(field.name)?.markAsDirty()"
        matSuffix
        [icon]="'close'"
        [title]="appService.language_dictionary.system_clear"
        [type]="'button-icon'"
        [borderRadius]="'circle'"
        [color]="'neutral'"
        [height]="'mini'"
        [iconSize]="16"
        [disabled]="field.disabled"
    >
    </fui-button>
    <fui-button
        *ngIf="field.inputType === 'password'"
        matSuffix
        [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="field.hide"
        (clickEvent)="field.hide = !field.hide"
        [icon]="field.hide ? 'eye-off' : 'eye'"
        [title]="
            field.hide ? appService.language_dictionary.hide_password : appService.language_dictionary.show_password
        "
        [type]="'button-icon'"
        [borderRadius]="'circle'"
        [color]="'neutral'"
        [height]="'mini'"
        [iconSize]="16"
    >
    </fui-button>
    <ng-container *ngIf="field?.trailingButton">
        <fui-button
            matSuffix
            (clickEvent)="outputEvent.emit({ action: field?.trailingButton?.action })"
            [ngClass]="'input_trailing-button'"
            [icon]="field?.trailingButton.icon"
            [title]="field?.trailingButton.title"
            [type]="'button-icon'"
            [borderRadius]="'circle'"
            [color]="'neutral'"
            [height]="field?.trailingButton?.height || 'mini'"
            [disabled]="field.disabled"
        >
        </fui-button>
    </ng-container>
    <ng-container *ngFor="let validation of field.validations" ngProjectAs="mat-error">
        <mat-error
            *ngIf="group?.get(field.name)?.hasError(validation.name)"
            [innerHTML]="
                validation.name === 'serverError' ? group?.get(field.name)?.errors?.serverError : validation.message
            "
        >
        </mat-error>
    </ng-container>
    <mat-error *ngIf="group?.get(field.name)?.hasError('inputMaskError')">
        {{ group?.get(field.name)?.errors?.inputMaskError }}
    </mat-error>
    <mat-error *ngIf="group?.get(field.name)?.hasError('moreThan')">
        {{ appService.language_dictionary.value_cannot_less }}
    </mat-error>
</mat-form-field>
